import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AuthenticationState } from './authentication-state';
import { UrlBuilder } from '../core/url-builder/url-builder';

@Component({
    selector: 'logout-page',
    template: require('./logout-page.component.html'),
    styles: [require('./logout-page.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoutPageComponent {
    constructor(private authState: AuthenticationState, private urlBuilder: UrlBuilder) {
        this.logout();
    }

    private async logout() {
        await this.authState.logout();

        const isExistReturnUrl = !!this.urlBuilder.esa().getExistingReturnUrl();
        await this.urlBuilder.esa().login().reload({ saveReturnUrl: isExistReturnUrl });
    }
}